import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface FAQItem {
    _id?: string
    question: LocalizedString
    answer: LocalizedString
    category?: LocalizedString
}

export interface FAQPage {
    _id?: string
    hero: {
        title: LocalizedString
        description: LocalizedString
    }
    faqs: FAQItem[]
    createdAt?: string
    updatedAt?: string
}

export const faqService = {
    getFAQPage: async () => {
        const res = await api.get<FAQPage>('/faq')
        return res.data
    },
    updateFAQPage: async (data: Partial<FAQPage>, translate: boolean = false) => {
        const res = await api.put<FAQPage>('/faq', data, { params: { translate } })
        return res.data
    }
}
